module.exports = __webpack_public_path__ + "static/Fastly-94524bcbe3803e0e704b6b7621b35c3a.jpg";